export default __webpack_public_path__ + "static/media/bg-interna03.7f924bf3.jpg";